import { trackingPageOrderSchema } from "@redotech/order-tracking-common/tracking-page-order-definition";
import * as z from "zod";

export const getRecentOrder = {
  name: "getRecentOrder" as const,
  input: z.object({}),
  output: trackingPageOrderSchema.nullable(),
};
